/** Country options aligned with API admin_profile validation. */
export const ADMIN_COUNTRY_OPTIONS = [
  { text: 'United States', value: 'USA' },
  { text: 'Canada', value: 'Canada' },
  { text: 'United Kingdom', value: 'United Kingdom' },
  { text: 'India', value: 'India' },
  { text: 'Australia', value: 'Australia' },
  { text: 'Germany', value: 'Germany' },
  { text: 'France', value: 'France' },
  { text: 'Japan', value: 'Japan' },
  { text: 'Brazil', value: 'Brazil' },
  { text: 'Mexico', value: 'Mexico' },
  { text: 'Italy', value: 'Italy' },
  { text: 'Spain', value: 'Spain' },
  { text: 'Netherlands', value: 'Netherlands' },
  { text: 'Sweden', value: 'Sweden' },
  { text: 'Norway', value: 'Norway' },
  { text: 'Singapore', value: 'Singapore' },
  { text: 'United Arab Emirates', value: 'United Arab Emirates' },
  { text: 'South Africa', value: 'South Africa' },
  { text: 'New Zealand', value: 'New Zealand' },
  { text: 'Ireland', value: 'Ireland' },
]

export default ADMIN_COUNTRY_OPTIONS
